

<template>
  <div>
    <!-- Header Area Start -->
    <header class="header_area header_black">
      <top-nav-menu />
    </header>
    <menu-page-area/>
  </div>
</template>
<script>
import MenuPageArea from "../components/MenuPageArea";

import TopNavMenu from "../components/menus/TopNavMenu";
export default {
  name: 'Menu',
  components: { MenuPageArea,TopNavMenu},
  data() {
    return {
      breadcrumb: {
        title: 'Food Menu',
        link: 'Menu'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Menu.vue